
import kotlinx.browser.document
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.style
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import kotlin.js.Promise

fun JQid(id:String) = document?.getElementById(id)
fun JQcls(cls:String) = document?.getElementsByClassName(cls)
fun JQ(selector :String) = document?.querySelector(selector)

fun Element.toggleCheck() {

    this as HTMLInputElement

    if(this.type != "checkbox")
        throw Exception("error - toggleCheck() called on a non-checkbox input")

    //invert checked status
    this.checked = !this.checked;
}

fun pickAString(strings: () -> Array<String>): String {
    val stringArray = strings()
    return stringArray.random()
}

fun pickAString(vararg strings : String) : String = pickAString(strings.toList())
fun pickAString(strings : List<String>) :String = strings.random()














